module.exports = __webpack_public_path__ + "img/hzhb.40e0e088.png";